module.exports = __webpack_public_path__ + "src/images/measurements/armLength.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/armLength.jpg
// module id = 1140
// module chunks = 0